import { Box, Divider, Stack, Switch, Typography } from "@mui/material";
import TopHeadingDividerComponent from "../AccountSetting/TopHeadingDividerComponent";
import IOSSwitch from "./IOSSwitch";
const notificationsSettingData = [
  {
    primary: "Likes & Comments",
    secondary: "Joy say painful moved reached end",
  },
  {
    primary: "Reply to My comments",
    secondary: "Ask a quick six seven offer see among.",
  },
  {
    primary: "Subscription",
    secondary: "Joy say painful removed reached end.",
  },
  {
    primary: "Birthdays",
    secondary: "Contened he gentleman agreeble do be",
  },
  {
    primary: "Events",
    secondary: "Fulfilled direction use continually.",
  },
  {
    primary: "Email notifications",
    secondary: "As hastened oh produced prospect.",
  },
  {
    primary: "push notifications",
    secondary: "Rendered sox say his striking confined.",
  },
];
function NotificationSettingSection() {
  return (
    <Stack
      sx={{
        bgcolor: "#ffffff",
        p: "20px",
        borderRadius: "20px",
        pb: "100px",
      }}
    >
      <TopHeadingDividerComponent
        primary="Notifications"
        secondary="Tried law yet style child. The bore of true of no be deal. Frequently sufficient to be unaffected. The furnished she concluded depending procuring concealed."
      />
      <Stack spacing={3} sx={{ pt: "12px" }}>
        {notificationsSettingData.map((data) => (
          <Stack
            direction="row"
            sx={{
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <TopHeadingDividerComponent
                primary={data.primary}
                secondary={data.secondary}
                divider={false}
                primaryFontSize="18px"
                primaryLineHeight="21.78px"
                secondaryBottomPadding="0px"
              />
            </Box>{" "}
            <IOSSwitch />
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}

export default NotificationSettingSection;
